<template>
  <div id="app" class="app">
    <mt-header fixed title="查询工程建设合同">
        <router-link to="./htl" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header>
    <div class="bodyDiv">
      <div class="certent">
        <div class="cerBotjzjd">
          <div class="jzjdMk mk01">
            <p class="mkH">工程建设合同总数</p>
            <p class="money"><span>{{gcjshtList.count}}</span>份</p>
          </div>
          <div class="jzjdMk mk02">
            <p class="mkH">到期工程建设合同</p>
            <p class="money"><span>{{gcjshtList.expire}}</span>份</p>
          </div>
          <div class="jzjdMk mk03">
            <p class="mkH">未到期工程建设合同</p>
            <p class="money"><span>{{gcjshtList.undue}}</span>份</p>
          </div>
        </div>
      </div>
      <div class="cwdbTab">
        <div class="cerTop">
          <div class="certit"><span class="kuang"></span>工程建设合同表</div>
        </div>
        <div class="zyjjdjbUl" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <div class="zyjjdjbLi" v-for="(item,index) in msgList" :key="index">
            <div class="liLeft">
              <div class="liA"><span>{{item.ttlamt}}</span> 元</div>
              <div class="liB">{{item.contractno}}</div>
            </div>
            <div class="liRight">
              <div class="rTop">
                <div class="liL">{{item.contractname}}</div>
                <div class="liR">{{item.dt}}编制</div>
              </div>
              <div class="liT">{{item.contractstartdate}} 至 {{item.contractenddate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { gcjshtSearch, gcjshtListSearch } from "@/api/htl";
import { doCreate, getDicTab } from "@/utils/config";
import { Toast } from 'mint-ui';
export default {
  name: "gcjshtinfo",
  data() {
    return {
      loading: false,
      startJz: false,
      active: "",
      activeIndex: "1",
      xzqhName: "",
      xzqhCode: "",
      gcjshtList: [],
      msgList: [],
      pageObj: {
        start: 0,
        pagesize: 10,
        orgcode: window.sessionStorage.getItem("xzqhCode")
      },
    };
  },
  methods: {
    //查询工程建设合同
    gcjsht() {
      let url = "/gk/findGcjshthz.open?orgcode=" + this.xzqhCode;
      let _this = this;
      gcjshtSearch(url).then(res => {
        let data = res.data;
        _this.gcjshtList = data.result;
      });
    },

    //懒加载数据
    loadMore() {
      this.loading = true;
      if(!this.startJz){
        this.pageObj.start = 0;
        this.startJz = true;
      }else{
        this.pageObj.start += 10;
      }
      this.gcjshtPage();
    },

    //工程建设合同-列表
    gcjshtPage() {
      let obj = Object.assign({}, this.pageObj);
      let url = "/gk/findGcjsht.open?";
      let _this = this;
      gcjshtListSearch(url, obj).then(res => {
        let data = res.data;
        if (data.errmsg == "操作成功") {
          if(data.result.content.length == 0){
            Toast({
              message: '已到最底部啦!',
              iconClass: 'mintui mintui-success'
            });
          }else{
            _this.msgList = _this.msgList.concat(data.result.content);
            this.loading = false;
          }
        } else {
          _this.$message.error(data.errmsg);
        }
      });
    },

    changeColor(active) {
      if (active == 1) {
        this.$router.push("/cwl");
      } else if (active == 2) {
        this.$router.push("/zcl");
      } else if (active == 3) {
        this.$router.push("/htl");
      }
      this.activeIndex = active;
    }
  },
  mounted() {
    this.xzqhName = window.sessionStorage.getItem("xzqhName");
    this.xzqhCode = window.sessionStorage.getItem("xzqhCode");
    this.gcjsht();
  }
};
</script>

<style lang="scss" scoped>
.app {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 40px;
  background: #fff;
  .bodyDiv {
    padding: 0;
    margin: 0;
    flex: 1;
    height: 0;
    overflow: scroll;
  }
  .banner {
    width: 100%;
    height: 160px;
    background: url("../../../public/images/banner.png") no-repeat;
    background-size: 100% 100%;
  }
  .address {
    padding: 10px;
    span {
      display: inline-block;
    }
    .affleft {
      width: 65%;
      padding-right: 10px;
    }
    .addright {
      width: 34%;
    }
  }
  .certent {
    padding: 12px;
    background: #fff;
    border-bottom: 10px solid #eee;
    .cerBotjzjd {
      width: 100%;
      height: 100px;
      display: flex;
      .jzjdMk{
        flex: 1;
        margin: 0 5px;
        padding: 15px 10px;
        line-height: 20px;
        border-radius: 6px;
        color: #fff;
        text-align: center;
        .money{
          span{
            font-size: 18px;
          }
        }
        .mkH{
          height: 40px;
          margin-bottom: 8px;
        }
      }
      .mk01{
        background: linear-gradient(to right, #fac756 , #f87220); /* 标准的语法 */
        background: -webkit-linear-gradient(to right, #fac756 , #f87220); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right, #fac756 , #f87220); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right, #fac756 , #f87220); /* Firefox 3.6 - 15 */
      }
      .mk02{
        background: linear-gradient(to right, #66d232 , #21b140); /* 标准的语法 */
        background: -webkit-linear-gradient(to right, #66d232 , #21b140); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right, #66d232 , #21b140); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right, #66d232 , #21b140); /* Firefox 3.6 - 15 */
      }
      .mk03{
        background: linear-gradient(to right, #4cb6f6 , #3397f1); /* 标准的语法 */
        background: -webkit-linear-gradient(to right, #4cb6f6 , #3397f1); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right, #4cb6f6 , #3397f1); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right, #4cb6f6 , #3397f1); /* Firefox 3.6 - 15 */
      }
    }
  }
  .cerTop{
    padding: 10px;
    .certit{
      color: #333;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      .kuang{
        width: 6px;
        height: 22px;
        background: #2a8cef;
        display: inline-block;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
  }
  .zyjjdjbUl{
    padding: 0 12px;
    border-bottom: 1px solid #f6f6f6;
    .zyjjdjbLi{
      border-top: 1px solid #f6f6f6;
      display: flex;
      padding: 10px 0;
      .liLeft{
        color: #666;
        flex: 1;
        border-right:1px solid #ccc;
        .liA{
          line-height: 24px;
          span{
            font-size: 20px;
            color: #d26234;
          }
        }
        .liB{
          color:#888;
          padding: 5px 0 0 0;
        }
      }
      .liRight{
        flex: 1.6;
        padding-left: 10px;
        .rTop{
          display: flex;
          .liL{
            flex: 1;
            line-height: 24px;
            font-size: 15px;
            color: #333;
            font-weight: bold;
            text-overflow:ellipsis;
            overflow:hidden;
            white-space:nowrap;
          }
          .liR{
            flex: 1;
            line-height: 24px;
            border: 1px solid #bd8f6d;
            color: #cc6d67;
            text-align: center;
          }
        }
        .liT{
          color:#888;
          padding: 6px 0 0 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.app {
  .mint-header {
    background-color: #2a8cef;
  }
  .mint-header-title {
    font-size: 18px;
  }
  .el-select {
    width: 100%;
  }
  .el-table th{
    background:#ddecff;
    color:#333;
  }
}
</style>
